import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;

  const images = listing.images;
  const videoLinks = listing.attributes.publicData.videoLinks;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <div className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        videoLinks={videoLinks}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        listingTitle={listing?.attributes?.title}
      />
    </div>
  );
};

export default SectionGallery;
